var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88909 11.3033C10.2796 11.6938 10.9128 11.6938 11.3033 11.3033C11.6938 10.9128 11.6938 10.2796 11.3033 9.88909L7.41422 6L11.3033 2.11092C11.6938 1.7204 11.6938 1.08723 11.3033 0.696707C10.9128 0.306183 10.2796 0.306183 9.88909 0.696707L6.00001 4.58579L2.11092 0.696702C1.72039 0.306178 1.08723 0.306177 0.696704 0.696702C0.306179 1.08723 0.30618 1.72039 0.696704 2.11092L4.58579 6L0.696702 9.88909C0.306178 10.2796 0.306177 10.9128 0.696702 11.3033C1.08723 11.6938 1.72039 11.6938 2.11092 11.3033L6.00001 7.41422L9.88909 11.3033Z",
    fill: "#D94444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.ad8cec223c453f7199c61ed5f76a06c8.svg";
export { ForwardRef as ReactComponent };